import React, { useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import checkInView from 'shared/utils/checkInView';
import {
  container,
  inner,
  cell,
  leftEnter,
  leftEnterActive,
  leftEnterDone,
  leftExit,
  leftExitActive,
  leftExitDone,
  rightEnter,
  rightEnterActive,
  rightEnterDone,
  rightExit,
  rightExitActive,
  rightExitDone
} from './styles.mod.scss';

export default function SlideContainer({
  renderLeft,
  renderRight,
  showRight,
  className
}) {
  const rightContainer = useRef();

  useEffect(() => {
    if (showRight) {
      checkInView(rightContainer.current);
    }
  }, [showRight]);

  return (
    <div className={classnames(container, className)}>
      <div className={inner}>
        <CSSTransition
          classNames={{
            enter: leftEnter,
            enterActive: leftEnterActive,
            enterDone: leftEnterDone,
            exit: leftExit,
            exitActive: leftExitActive,
            exitDone: leftExitDone
          }}
          in={!showRight}
          timeout={250}
        >
          <div className={cell}>{renderLeft()}</div>
        </CSSTransition>

        <CSSTransition
          classNames={{
            enter: rightEnter,
            enterActive: rightEnterActive,
            enterDone: rightEnterDone,
            exit: rightExit,
            exitActive: rightExitActive,
            exitDone: rightExitDone
          }}
          in={showRight}
          timeout={250}
          mountOnEnter
        >
          <div className={cell} ref={rightContainer}>
            {renderRight()}
          </div>
        </CSSTransition>
      </div>
    </div>
  );
}
